<template>
  <v-container fluid id="docForm" class="subtitle-2 text--primary">
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Create Sale</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row dense id="po">
          <v-col cols="12" xs="12" sm="12" md="4">
            <v-autocomplete
              autocomplete="off"
              dense
              outlined
              v-model="record.CardCode"
              :items="customers"
              label="Customer"
              item-text="Name"
              item-value="id"
            >
              <template v-if="enableCreate" v-slot:no-data>
                <v-row align="center" justify="center">
                  <v-btn
                    :loading="searchingProduct"
                    class="ma-2"
                    color="accent"
                    dark
                    small
                    elevation="0"
                    @click="customerModal()"
                  >
                    <v-icon left>mdi-plus</v-icon>Create A Customer
                  </v-btn>
                </v-row>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col cols="4" xs="4" md="4">
            <v-text-field
              autocomplete="off"
              type="text"
              v-model="DocNum"
              outlined
              dense
              filled
              readonly
              label="Order No"
            ></v-text-field>
          </v-col>

          <v-col cols="8" xs="8" md="4">
            <span v-if="role != 3" style="font-weight: bold; font-size: 16px"
              >Date: {{ date }}</span
            >
            <DatePicker
              v-else
              @date="setDate"
              :myDate="date"
              :title="`Date`"
              ref="dateRef"
            ></DatePicker>
          </v-col>

          <v-col cols="12">
            <v-btn text color="accent" @click="saleModal">
              <v-icon>mdi-plus</v-icon>Add Product
            </v-btn>

            <v-data-table
              light
              dense
              :items-per-page="pageItems"
              :headers="headers"
              :items="orderItems"
              item-key="LineNum"
              hide-default-footer
              disable-sort
              :mobile-breakpoint="zeroValue"
              :calculate-widths="trueValue"
            >
              <template v-slot:item.Quantity="{ item }">
                <span style="margin-right: 15px !important">{{
                  item.Quantity
                }}</span>
              </template>

              <template v-slot:item.Price="{ item }">
                <span style="margin-right: 15px !important">{{
                  item.Price.toLocaleString()
                }}</span>
              </template>

              <template v-slot:item.DisplayTotal="{ item }">
                <span>{{ item.DisplayTotal.toLocaleString() }}</span>
              </template>

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn @click="deleteRow(item)" color="red" icon>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <!-- end -->

              <template v-slot:item.Profit="{ item }">
                {{ (item.Price - item.BuyingPrice) * item.Quantity }}
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <!-- outsourced row -->
        <v-row>
          <v-col cols="12">
            <v-btn text color="accent" @click="outModal">
              <v-icon>mdi-plus</v-icon>Add Outsourced
            </v-btn>
          </v-col>

          <v-col cols="12">
            <v-data-table
              light
              dense
              :items-per-page="pageItems"
              :headers="outHeaders"
              :items="outArray"
              item-key="LineNum"
              hide-default-footer
              disable-sort
              :mobile-breakpoint="zeroValue"
              :calculate-widths="trueValue"
            >
              <template v-slot:item.Quantity="{ item }">
                <span style="margin-right: 15px !important">{{
                  item.Quantity
                }}</span>
              </template>

              <template v-slot:item.Price="{ item }">
                <span style="margin-right: 15px !important">{{
                  item.Price.toLocaleString()
                }}</span>
              </template>

              <template v-slot:item.DisplayTotal="{ item }">
                <span>{{ item.DisplayTotal.toLocaleString() }}</span>
              </template>

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn @click="deleteOutRow(item)" color="red" icon>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>
        </v-row>
        <!-- end of outsourced row -->

        <v-row v-show="multiplePayment == 'Y'">
          <v-col cols="12">
            <v-btn
              v-show="
                (multiplePayment == 'Y' && orderItems.length > 0) ||
                this.outArray.length > 0
              "
              color="primary"
              text
              @click.native="paymentDialog = true"
            >
              <v-icon left>mdi-plus</v-icon>Add Payment
            </v-btn>
          </v-col>

          <v-col cols="12" xs="12" style="margin-top: -30px">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Account</th>
                    <th class="text-left">Amount Paid</th>
                    <th class="text-left">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in payments" :key="item.account">
                    <td>{{ item.account }}</td>
                    <td>{{ item.SumApplied.toLocaleString() }}</td>
                    <td>
                      <v-btn @click="deleteAccount(item)" color="red" icon>
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

          <v-col cols="12" xs="12">
            <v-row dense class="genFont mt-2">
              <!-- <v-col cols="12">Total Bef Disc: {{totalDisplayAmount}}</v-col> -->

              <v-col cols="12">Bill: {{ totalAfterDiscDisplay }}</v-col>

              <v-col cols="12">Paid: {{ mPaid }}</v-col>

              <v-col cols="12">Balance: {{ displayMBalance }}</v-col>

              <v-col cols="12"
                ><span style="font-size: 18px"
                  >Total Profit:
                  {{ (orderProfit + outTotalProfit).toLocaleString() }}</span
                ></v-col
              >

              <v-col cols="8">
                <v-autocomplete
                  autocomplete="off"
                  dense
                  outlined
                  v-model="UserSign"
                  :items="users"
                  label="Sold By/ Sale Person"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-btn
              color="accent"
              @click="sendData"
              :loading="$store.state.btnLoader"
            >
              <v-icon left>mdi-content-save</v-icon>Save
            </v-btn>
          </v-col>
        </v-row>

        <!-- Payment dialog -->
        <v-dialog v-model="paymentDialog">
          <v-card>
            <v-toolbar dense color="accent" dark>
              <v-toolbar-title>Record Payment</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="paymentDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" xs="12">
                    <v-autocomplete
                      autocomplete="off"
                      hide-details
                      dense
                      outlined
                      v-model="paymentItem.o_a_c_t_s_id"
                      :items="accounts"
                      label="Account"
                      item-text="Name"
                      item-value="id"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" xs="12">
                    <v-text-field
                      autocomplete="off"
                      type="text"
                      v-model="paymentItem.SumApplied"
                      label="Amount Paid"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="accent" @click="addPayment" :loading="loader">
                      <v-icon left>mdi-plus</v-icon>Add
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of payment modal-->

        <!-- Sale dialog -->
        <v-dialog v-model="saleDialog">
          <v-card>
            <v-toolbar dense color="accent" dark>
              <v-toolbar-title>Product Selection</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="saleDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid class="subtitle-2 text--primary">
                <v-row>
                  <v-col cols="12" xs="12" md="4">
                    <v-autocomplete
                      autocomplete="off"
                      dense
                      outlined
                      single-line
                      v-model="saleItem.id"
                      :items="products"
                      label="Select Product"
                      item-text="product.Name"
                      item-value="id"
                      @change="setOrderItem"
                    >
                      <template v-if="enableCreate" v-slot:no-data>
                        <v-row align="center" justify="center">
                          <v-btn
                            :loading="searchingProduct"
                            class="ma-2"
                            color="accent"
                            dark
                            small
                            elevation="0"
                            @click="productModal()"
                          >
                            <v-icon left>mdi-plus</v-icon>Create A Product
                          </v-btn>
                        </v-row>
                      </template>
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" xs="12" md="4" style="margin-top: -20px">
                    <v-text-field
                      autocomplete="off"
                      type="text"
                      readonly
                      filled
                      v-model="saleItem.available"
                      label="Available Qty"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" xs="6" md="4" style="margin-top: -20px">
                    <v-text-field
                      autocomplete="off"
                      type="text"
                      v-model="saleItem.Quantity"
                      @input="qtyChanged(saleItem)"
                      label="Qty"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" xs="6" md="4" style="margin-top: -20px">
                    <v-text-field
                      autocomplete="off"
                      type="text"
                      v-model="saleItem.BuyingPrice"
                      label="Buying Price"
                      readonly
                      filled
                      @input="qtyChanged(saleItem)"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" xs="6" md="4" style="margin-top: -20px">
                    <v-text-field
                      autocomplete="off"
                      type="text"
                      v-model="saleItem.Price"
                      label="Selling Price"
                      @input="qtyChanged(saleItem)"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" xs="6" md="4" style="margin-top: -20px">
                    Profit:
                    <span style="padding: 2px; font-bold">{{
                      (saleItem.Price - saleItem.BuyingPrice) *
                      saleItem.Quantity
                    }}</span>
                  </v-col>

                  <v-col cols="12" xs="12"
                    >Total: {{ saleItem.DisplayTotal }}</v-col
                  >

                  <v-col cols="12">
                    <v-btn color="accent" @click="addProduct" :loading="loader">
                      <v-icon left>mdi-plus</v-icon>Add
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of products modal-->

        <!-- Outsourced dialog -->
        <v-dialog v-model="outsourcedDialog">
          <v-card>
            <v-toolbar dense color="accent" dark>
              <v-toolbar-title>Outsourced Product</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="outsourcedDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid class="subtitle-2 text--primary">
                <v-row>
                  <v-col cols="12" xs="12" md="4">
                    <v-text-field
                      autocomplete="off"
                      type="text"
                      v-model="outItem.Name"
                      label="Name"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" xs="6" md="4">
                    <v-text-field
                      autocomplete="off"
                      type="number"
                      v-model="outItem.Quantity"
                      @input="qtyOutChanged(outItem)"
                      label="Qty"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" xs="6" md="4">
                    <v-text-field
                      autocomplete="off"
                      type="number"
                      v-model="outItem.BuyingPrice"
                      @input="qtyOutChanged(outItem)"
                      label="Buying Price"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" xs="6" md="4">
                    <v-text-field
                      autocomplete="off"
                      type="number"
                      v-model="outItem.Price"
                      @input="qtyOutChanged(outItem)"
                      label="Selling Price"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="6" xs="6" md="4">
                    Profit: {{ outsourcedProfit.toLocaleString() }}</v-col
                  >

                  <v-col cols="12" xs="12"
                    >Total: {{ outItem.DisplayTotal }}</v-col
                  >

                  <v-col cols="12">
                    <v-btn
                      color="accent"
                      @click="addOutProduct"
                      :loading="loader"
                    >
                      <v-icon left>mdi-plus</v-icon>Add
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of outsourced modal-->

        <!-- Customer quick add dialog -->
        <v-dialog v-model="customerDialog" max-width="750px">
          <v-card>
            <v-toolbar dense color="primary" dark>
              <v-toolbar-title>Create A Customer</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="customerDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <customer-editor
                  :initial="accountItem"
                  @data="saveCustomer"
                ></customer-editor>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of modal-->

        <!-- product quick add dialog -->
        <v-dialog v-model="productDialog" max-width="750px">
          <v-card>
            <v-toolbar dense color="primary" dark>
              <v-toolbar-title>Create A Product</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="productDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <product-editor
                  :docCreate="true"
                  :initial="productItem"
                  @data="saveProduct"
                ></product-editor>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of modal-->

        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>


<script>
import { http } from "@/common/index";
import CustomerEditor from "@/components/subscriber/customers/_components/quick-editor.vue";
import ProductEditor from "@/components/subscriber/products/creation/_components/quick-editor.vue";
export default {
  name: "PosPortal",
  components: {
    CustomerEditor,
    ProductEditor,
  },
  props: {
    docCreate: {
      type: Boolean,
    },
    loaderOff: {
      type: Boolean,
    },
    copyStatus: {
      type: Boolean,
    },
  },
  data: () => ({
    zeroValue: 0,
    enableCreate: true,
    customerDialog: false,
    productDialog: false,
    productItem: {},
    accountItem: {},
    trueValue: true,
    searchingProduct: false,
    record: {},
    outsourcedDialog: false,
    outItem: {},
    outArray: [],
    UserSign: null,
    enablePriceList: "N",
    saleDialog: false,
    SellDeficit: "",
    saleItem: {},
    ref2: null,
    IMEI: null,
    SoldBy: null,
    loader: false,
    pageItems: 100,
    DiscOnTotal: null,
    multiplePayment: "Y",
    selectedProduct: null,
    SumApplied: null,
    DocNum: null,
    selectedItems: [],
    activeRow: null,
    singleSelect: true,
    paymentItem: {},
    paymentDialog: false,
    payments: [],
    orderItems: [],
    customers: [],
    products: [],
    accounts: [],
    taxGroups: [],
    stores: [],
    users: [],
    date: new Date().toISOString().substr(0, 10),
    todayDate: new Date().toISOString().substr(0, 10),
    dateReadonly: "Y",
    clearDate: "",
    headers: [
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "BP", value: "BuyingPrice" },
      { text: "SP", value: "Price" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Action", value: "action" },
    ],
    outHeaders: [
      { text: "Product", value: "Name" },
      { text: "Qty", value: "Quantity" },
      { text: "Buying Price", value: "BuyingPrice" },
      { text: "Selling Price", value: "Price" },
      { text: "Total", value: "DisplayTotal" },
      { text: "Profit", value: "LineProfit" },
      { text: "Action", value: "action" },
    ],
    paymentHeaders: [
      { text: "Account", value: "account" },
      { text: "Amount", value: "SumApplied" },
      { text: "Action", value: "action" },
    ],
  }),
  computed: {
    userName() {
      return localStorage.getItem("userName");
    },
    role() {
      return localStorage.getItem("userRole");
    },
    activeStore() {
      return localStorage.getItem("store_id");
    },
    orderProfit() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map((item) => {
            const amount =
              item.Price * item.Quantity - item.BuyingPrice * item.Quantity;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    outsourcedProfit() {
      let qty = 0;
      let buyingPrice = 0;
      let sellingPrice = 0;
      let profit = 0;

      qty = this.outItem.Quantity;
      buyingPrice = this.outItem.BuyingPrice;
      sellingPrice = this.outItem.Price;

      profit = qty * sellingPrice - qty * buyingPrice;

      return profit;
    },
    totalAmount() {
      let total = 0;
      if (typeof this.orderItems != "undefined" && this.orderItems.length > 0) {
        return this.orderItems
          .map((item) => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    outTotalAmount() {
      let total = 0;
      if (typeof this.outArray != "undefined" && this.outArray.length > 0) {
        return this.outArray
          .map((item) => {
            const amount = item.LineTotal;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    mTotalPayments() {
      let total = 0;
      if (typeof this.payments != "undefined" && this.payments.length > 0) {
        return this.payments
          .map((item) => {
            const amount = parseFloat(item.SumApplied);
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    mPaid() {
      return this.mTotalPayments.toLocaleString();
    },
    mBalance() {
      let bill = 0;
      let paid = 0;
      bill = this.totalAfterDisc;
      paid = this.mTotalPayments;
      const balance = bill - paid;
      return balance;
    },
    displayMBalance() {
      return this.mBalance.toLocaleString();
    },
    balance() {
      let sum = 0;
      if (this.SumApplied) {
        sum = this.SumApplied;
      }

      let disc = 0;
      if (this.DiscOnTotal) {
        disc = this.DiscOnTotal;
      }

      const balance =
        this.totalAmount +
        this.outTotalAmount -
        parseFloat(sum) -
        parseFloat(disc);
      return balance;
    },
    outTotalProfit() {
      let total = 0;
      if (typeof this.outArray != "undefined" && this.outArray.length > 0) {
        return this.outArray
          .map((item) => {
            const amount = item.LineProfit;
            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    totalAfterDisc() {
      let disc = 0;
      if (this.DiscOnTotal) {
        disc = this.DiscOnTotal;
      }
      const total = this.totalAmount + this.outTotalProfit - parseFloat(disc);
      return total;
    },
    totalAfterDiscDisplay() {
      return this.totalAfterDisc.toLocaleString();
    },
    displayBalance() {
      return this.balance.toLocaleString();
    },
    totalDisplayAmount() {
      return this.totalAmount.toLocaleString();
    },
  },
  methods: {
    saleModal() {
      this.saleItem = {};
      this.saleDialog = true;
    },
    productModal() {
      this.productDialog = true;
    },
    customerModal() {
      this.customerDialog = true;
    },
    outModal() {
      this.outItem = {};
      this.outsourcedDialog = true;
    },
    saveProduct(data) {
      const url = "/products";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.getProducts();
            self.loader = false;
            self.productDialog = false;
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show("Product added Successfully", "green");
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    saveCustomer(data) {
      const url = "/customers";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            const customer = res.ResponseData;
            self.customers = [...this.customers, customer];
            self.record.CardCode = customer.id;
            self.$refs.snackbar.show("Customer Added Successully", "green");
            self.customerDialog = false;
            self.$store.commit("btnLoader", false);
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    addProduct() {
      if (this.saleItem.Price < this.saleItem.LowerLimit) {
        const msg = `You can not sell below ${this.saleItem.LowerLimit}`;
        this.$refs.snackbar.show(msg, "red");
      } else {
        if (
          this.saleItem.Quantity > this.saleItem.available &&
          this.SellDeficit == "N"
        ) {
          this.$refs.snackbar.show(
            `Insufficient Stock Available: ${this.saleItem.available}`,
            "red"
          );
        } else {
          const self = this;
          const initArray = [];
          initArray.push(self.saleItem);
          self.orderItems = [...self.orderItems, ...initArray];
          this.saleItem = {};
          this.saleDialog = false;
        }
      }
    },
    addOutProduct() {
      if (
        this.outItem.Name == undefined ||
        this.outItem.Quantity == undefined ||
        this.outItem.Price == undefined
      ) {
        this.$refs.snackbar.show("Please fill all the fields!", "red");
      } else {
        const self = this;
        const initArray = [];
        self.outItem.LineNum = new Date().getTime();
        self.outItem.Commission = 0;
        self.outItem.Commission = this.outsourcedProfit;
        self.outItem.LineProfit = this.outsourcedProfit;
        const LineTotal =
          parseFloat(this.outItem.Quantity) * parseFloat(this.outItem.Price);
        self.outItem.LineTotal = LineTotal;
        initArray.push(self.outItem);
        self.outArray = [...self.outArray, ...initArray];
        this.outItem = {};
        this.outsourcedDialog = false;
      }
    },
    addPayment() {
      const accoutId = this.paymentItem.o_a_c_t_s_id;
      if (accoutId == undefined) {
        this.$refs.snackbar.show("Please select payment mode!", "red");
      } else {
        if (this.paymentItem.SumApplied == undefined) {
          this.$refs.snackbar.show("Please enter amount paid!", "red");
        } else {
          const paymentAccount = this.payments.find((record) => {
            return record.o_a_c_t_s_id === accoutId;
          });

          if (paymentAccount == undefined) {
            const item = this.paymentItem;
            const account = this.accounts.find((record) => {
              return record.id === accoutId;
            });
            // check if payment mode exist

            const data = {
              o_a_c_t_s_id: account.id,
              account: account.Name,
              SumApplied: item.SumApplied,
              Remarks: item.Remarks,
            };
            this.payments.push(data);
            this.paymentItem = {};
            this.paymentDialog = false;
          } else {
            this.$refs.snackbar.show("That payment mode exist!", "red");
          }
          // end of check
        }
      }
    },
    deleteAccount(item) {
      const selectedRow = this.payments.find((record) => {
        return record.o_a_c_t_s_id === item.o_a_c_t_s_id;
      });
      const pos = this.payments.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.payments.splice(pos, 1);
    },
    printReceipt(data) {
      const p_products = data.rows;
      const total_cost = data.DocTotal;
      const total_payments = data.TotalPaid;
      const userName = data.userName;
      const customerName = "Peter Waithaka";
      const customerBalance = data.Balance;
      const receipt_no = data.DocNum;
      const DiscSum = data.DiscSum;
      const totalAfterDisc = data.totalAfterDisc;
      const ref2 = data.ref2;
      const seller = data.seller || data.userName;
      return http.post("http://localhost/print", {
        p_products,
        total_cost,
        DiscSum,
        totalAfterDisc,
        total_payments,
        userName,
        customerName,
        customerBalance,
        receipt_no,
        ref2,
        seller,
      });
    },
    setDate(date) {
      this.date = date;
    },
    deleteRow(item) {
      const selectedRow = this.orderItems.find((record) => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.orderItems.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.orderItems.splice(pos, 1);
      this.activeRow = null;
      this.selectedItems = [];
    },
    deleteOutRow(item) {
      const selectedRow = this.outArray.find((record) => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.outArray.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.outArray.splice(pos, 1);
    },
    selectedRow($event) {
      this.activeRow = $event.item.o_i_t_m_s_id;
    },
    qtyChanged(data) {
      let Price;
      let Quantity;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      const LineTotal = Math.round(Price * Quantity);

      const DisplayTotal = LineTotal.toLocaleString();
      // find item

      this.saleItem.LineTotal = LineTotal;
      this.saleItem.DisplayTotal = DisplayTotal;
    },
    qtyOutChanged(data) {
      let Price;
      let Quantity;
      if (data.Price) {
        Price = parseFloat(data.Price);
      } else {
        Price = 0;
      }
      if (data.Quantity) {
        Quantity = parseFloat(data.Quantity);
      } else {
        Quantity = 0;
      }
      const LineTotal = Price * Quantity;

      const DisplayTotal = LineTotal.toLocaleString();
      // find item

      this.outItem.LineTotal = LineTotal;
      this.outItem.DisplayTotal = DisplayTotal;
    },
    inputChanged(data) {
      if (parseFloat(data.Price) < parseFloat(data.BuyingPrice)) {
        this.$refs.snackbar.show(
          `You cannot sell below ${data.BuyingPrice}`,
          "red"
        );
      } else {
        let Price;
        let Quantity;
        let DiscSum;
        if (data.Price) {
          Price = parseFloat(data.Price);
        } else {
          Price = 0;
        }
        if (data.Quantity) {
          Quantity = parseFloat(data.Quantity);
        } else {
          Quantity = 0;
        }

        if (data.DiscSum) {
          DiscSum = parseFloat(data.DiscSum);
        } else {
          DiscSum = 0;
        }

        const TotalBefTax = Price * Quantity;

        // add tax
        const tax = this.taxGroups.find((record) => {
          return record.id === data.TaxId;
        });

        let taxAmount = 0;
        let taxRate = 0;
        if (tax) {
          taxRate = tax.Rate;
          taxAmount = (taxRate / 100) * TotalBefTax;
        }

        const TotalAfterTax = TotalBefTax + taxAmount;

        const LineTotal = TotalAfterTax - DiscSum;

        const DisplayTotal = LineTotal.toLocaleString();
        // find item
        const currentItem = this.orderItems.find((record) => {
          return record.LineNum === data.LineNum;
        });

        const pos = this.orderItems.indexOf(currentItem);
        if (pos === -1) {
          return;
        }
        // end of find

        // update record
        currentItem.TaxRate = taxRate;
        currentItem.TaxAmount = taxAmount;
        currentItem.LineTotal = LineTotal;
        currentItem.DisplayTotal = DisplayTotal;
        this.orderItems[pos] = currentItem;
      }
    },
    uomChanged(item, ugp1) {
      const ugp1Record = ugp1.find((record) => {
        return record.UomEntry === item.UomEntry;
      });

      if (ugp1Record) {
        this.saleItem.uomEntryName = ugp1Record.uomentry.UomName;
        this.saleItem.Price = ugp1Record.SellingPrice;
      }
    },
    setOrderItem() {
      const itm2Id = this.saleItem.id;
      const itm2 = this.products.find((record) => {
        return record.id == itm2Id;
      });
      const store_id = this.activeStore;

      const currentItem = {};
      const self = this;
      // fetch the product from database
      this.$store
        .dispatch("get", `/products/${itm2.product.id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            const product = res.ResponseData;

            // get price api call
            const qData = {
              product_id: product.id,
              SUoMEntry: product.SUoMEntry,
              o_p_l_n_s_id: product.itm4[0].o_p_l_n_s_id,
              store_id: store_id,
            };

            const url = "/price-calculation";
            self.$store.dispatch("post", { url, data: qData }).then((res) => {
              currentItem.Price = res.ResponseData.FINALSALESPRICE;
              console.log(res, "response");
              currentItem.bp = res.ResponseData.BuyingPrice;
              currentItem.BuyingPrice = res.ResponseData.BuyingPrice;
              currentItem.LowerLimit = res.ResponseData.LowerLimit;
              currentItem.LineTotal = 0;
              currentItem.DisplayTotal = 0;
              currentItem.priceLists = product.itm4;
              currentItem.o_p_l_n_s_id = product.itm4[0].o_p_l_n_s_id;
              // end

              // set selling price and store
              currentItem.available = itm2.AvailableQty;
              currentItem.ManualStatus = product.ugpentry.IsManual;
              currentItem.UomEntry = product.SUoMEntry;
              currentItem.ugp1 = product.ugpentry.ugp1;
              currentItem.o_i_t_m_s_id = itm2.product.id;
              currentItem.Name = itm2.product.Name;
              // currentItem.bp = itm2.product.BuyingPrice;
              // currentItem.BuyingPrice = itm2.BuyingPrice;
              currentItem.store_id = store_id;
              currentItem.LineNum = new Date().getTime();
              currentItem.TaxId = self.taxGroups[0].id;
              currentItem.TaxRate = null;
              currentItem.TaxAmount = null;
              currentItem.ref1 = null;
              currentItem.DiscSum = null;
              currentItem.PurchaseCurrency = null;
              currentItem.cnvRate = null;
              currentItem.BaseCurrencyTotal = null;
              self.saleItem = { ...self.saleItem, ...currentItem };
            });
            // end of api call
            // end of current item def
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
      // end of fetch
    },
    sendData() {
      if (
        (this.date == null || this.date == undefined) &&
        this.dateReadonly == "N"
      ) {
        this.$refs.snackbar.show("Please select date!", "red");
      } else {
        if (this.SoldBy == "Y" && this.UserSign == null) {
          this.$refs.snackbar.show("Please select the seller", "red");
        } else {
          if (this.orderItems.length > 0 || this.outArray.length > 0) {
            let balance = 0;
            if (this.multiplePayment == "N") {
              balance = this.totalAfterDisc - this.SumApplied;
            } else {
              balance = this.mBalance;
            }
            if (balance < 0) {
              this.$refs.snackbar.show(
                "Payments more than sale value not allowed!",
                "red"
              );
            } else {
              if (balance > 0 && this.record.CardCode == undefined) {
                this.$refs.snackbar.show("Please select customer", "red");
              } else {
                // get seller
                const sellerId = this.UserSign;
                let seller = {};
                if (sellerId !== null) {
                  seller = this.users.find((record) => {
                    return record.id === sellerId;
                  });
                }

                // end of get
                let saleDate = this.date;
                this.record = { ...this.record, DocDate: saleDate };
                const data = this.record;
                data.rows = this.orderItems;
                data.outRows = this.outArray;
                data.TargetType = null;
                data.BaseType = null;
                data.BaseEntry = null;
                data.ObjType = 14;
                data.DocTotal = this.totalAfterDisc;
                data.DocNum = this.DocNum;
                data.UserSign = this.UserSign;
                data.ref2 = this.ref2;
                data.seller = seller.name;
                let Dis = 0;
                if (this.DiscOnTotal == null) {
                  Dis = 0;
                } else {
                  Dis = this.DiscOnTotal;
                }
                data.DiscSum = Dis;
                data.totalAfterDisc = this.totalAfterDisc;
                if (this.multiplePayment == "N") {
                  data.TotalPaid = this.SumApplied;
                  data.Balance = this.balance;
                } else {
                  data.TotalPaid = this.mTotalPayments;
                  data.Balance = this.mBalance;
                }

                let saleType = "";
                if (data.Balance > 0) {
                  saleType = "credit";
                } else {
                  saleType = "cash";
                }
                data.saleType = saleType;

                data.userName = this.userName;
                // set payments
                const paidAmount = this.SumApplied;
                if (this.multiplePayment == "N") {
                  let paymentData = { o_a_c_t_s_id: 1, SumApplied: paidAmount };
                  this.payments.push(paymentData);
                }
                data.payments = this.payments;

                if (this.dateReadonly == "Y") {
                  data.DocDate = this.todayDate;
                }

                // const printData = data;
                // end

                // save data
                const url = "/documents";
                const self = this;
                this.$store.commit("btnLoader", true);
                this.$store
                  .dispatch("post", { url, data })
                  .then((res) => {
                    if (res.ResultCode == 1200) {
                      self.getDocNum();
                      const NewDate = this.record.DocDate;
                      self.record = {};
                      self.record = { ...self.record, DocDate: NewDate };
                      // if (self.clearDate == "Y") {
                      //   this.$refs.dateRef.clearDate();
                      // }
                      self.orderItems = [];
                      self.outArray = [];
                      self.SumApplied = 0;
                      self.payments = [];
                      self.DiscOnTotal = 0;
                      self.ref2 = null;
                      self.UserSign = null;
                      this.$refs.snackbar.show("Sale successful", "green");
                      self.$store.commit("btnLoader", false);
                    } else {
                      self.$store.commit("btnLoader", false);
                      this.$refs.snackbar.show(res.ResultDesc, "red");
                    }
                  })
                  .catch((err) => {
                    self.$store.commit("btnLoader", false);
                    this.$refs.snackbar.show(err, "red");
                  });
                // end
              }
              // balance < 0 curly brace
            }
          } else {
            this.$refs.snackbar.show(
              "You must have at least one product",
              "red"
            );
          }
        }
      }
    },
    getCustomers() {
      const self = this;
      this.$store
        .dispatch("get", `/customers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            const customers = res.ResponseData;
            customers.shift();
            self.customers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getProducts() {
      const self = this;
      const id = this.activeStore;
      this.$store
        .dispatch("get", `/stores/${id}`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.products = res.ResponseData.itm2;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getGenSettings() {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/general-settings`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.IMEI = res.ResponseData.IMEI;
            self.SoldBy = res.ResponseData.SoldBy;
            self.SellDeficit = res.ResponseData.SellDeficit;
            self.clearDate = res.ResponseData.clearDate;
            self.dateReadonly = res.ResponseData.dateReadonly;
            self.enablePriceList = res.ResponseData.enablePriceList;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getDocNum() {
      const self = this;
      this.$store
        .dispatch("get", `/document-numbering/14`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.DocNum = res.ResponseData.NextNumber;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getUsers() {
      const self = this;
      this.$store
        .dispatch("get", `/users`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.users = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    setDefaultRow() {
      const self = this;
      this.$store.dispatch("get", `/taxgroups/O`).then((res) => {
        if (res.ResultCode == 1200) {
          self.taxGroups = res.ResponseData;
        }
      });
    },
  },
  created() {
    this.setDefaultRow();

    Promise.all([
      this.getCustomers(),
      this.getProducts(),
      this.getStores(),
      this.getGenSettings(),
      this.getDocNum(),
      this.getAccounts(),
      this.getUsers(),
    ]);
  },
};
</script>

<style lang="scss" scoped>
.genFont {
  font-size: 1.3em;
  font-weight: 500;
}
</style>